module.exports = __webpack_public_path__ + "img/MUSA-14.ffdbde71.jpg";